<template>
  <div class="gezx-nav">
    <div class="gezx-nav-tx">
      <el-avatar
        :size="100"
        :src="'https://yuanpingjia-com-cn-1304761361.cos.ap-chongqing.myqcloud.com/keyankepu/keaixiaomaomaomengchongdongwutouxiangkatong_12095155.jpg.400.jpg'"
      />
      <div class="gezx-nav-tx-yhm">欢迎您，{{yonghuming}}</div>
    </div>
    <div class="gezx-nav-ul">
      <div class="gezx-nav-list" @click="tiaozhuanlianjie('/pc')">
        <el-icon :size="'18'" color="#296FAB"><User /></el-icon>
        <span class="gezx-nav-list-grxx">个人信息</span>
      </div>
      <div class="gezx-nav-list" @click="tiaozhuanlianjie('/pchd')">
        <el-icon :size="'18'" color="#296FAB"><Medal /></el-icon>
        <span class="gezx-nav-list-grxx">活动成果</span>
      </div>
      <div class="gezx-nav-list" @click="tiaozhuanlianjie('/')">
        <el-icon :size="'18'" color="#296FAB"><House /></el-icon>
        <span class="gezx-nav-list-grxx">返回首页</span>
      </div>
      <div class="gezx-nav-list" @click="loginout">
        <el-icon :size="'18'" color="#296FAB"><Wallet /></el-icon>
        <span class="gezx-nav-list-grxx">退出账号</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { post, get } from "@/utils/index";
import { ElMessage } from "element-plus";
import { User, Medal,House,Wallet } from "@element-plus/icons-vue";
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

// 是否登录
const islogin = () => {
  let token = window.localStorage.getItem("token");
  if (typeof token == "undefined" || token===null || token=='') {
    ElMessage({
      message: "请登录",
      type: "warning",
      duration: 1000,
      onClose: () => {
        // 跳转登录页
        router.push({
          path: "/login",
          query: {},
        });
      },
    });
  }
};
islogin()

let yonghuming= window.localStorage.getItem('username')


const tiaozhuanlianjie = (url) => {
  router.push({
    path: url,
    query: {
      idx: 0,
    },
  });
};

// 注销
const loginout = () => {
  ElMessage({
    message: "已退出系统！",
    duration: 1000,
    onClose: () => {
      // 清除token
      window.localStorage.removeItem("token");
      // 清除个人信息
      window.localStorage.removeItem("username");
      window.localStorage.removeItem("userInfo");
      // 清除url
      window.localStorage.removeItem("loginurl");
      router.push({
        path: "/",
        query: {},
      });
    },
  });

  // post("/member/logout").then((res) => {
  //   // 清除token
  //   window.localStorage.removeItem("token");
  //   // 清除个人信息
  //   window.localStorage.removeItem("userInfo");
  //   editlogin();
  //   ElMessage({
  //     message: "已退出系统！",
  //     duration: 1000,
  //     onClose: () => {
  //       router.push({
  //         path: "/",
  //         query: {},
  //       });
  //     },
  //   });
  // });
};
</script>

<style scoped>
.gezx-nav {
  float: left;
  width: 270px;
  height: auto;
  min-height: 500px;
}
.gezx-nav-tx {
  width: 270px;
  height: 240px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.gezx-nav-tx-yhm {
  margin-top: 20px;
}
.gezx-nav-ul {
  width: 270px;
  height: auto;
  margin-top: 20px;
}
.gezx-nav-ul:after {
  content: "";
  display: table;
  clear: both;
}
.gezx-nav-list {
  cursor: pointer;
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  box-shadow: 0 0 8px rgba(6, 56, 115, 0.1);
  align-items: center;
  border-right: 2px solid #fff;
  margin-bottom: 10px;
}
.gezx-nav-list:hover {
  border-right: 2px solid #296fab;
}
.gezx-nav-list-grxx {
  margin-left: 10px;
}
</style>
